import registerearn from "../../../../../src/assets/registerearn.png";
import shareearn from "../../../../../src/assets/shareearn.png";
import dividend from "../../../../../src/assets/divideearn.png";
import { textVariants } from "@/src/components/Text/Text";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

const HowItWorks = () => {
  const { t } = useTranslation();
  const trans = (key: string) => t(`app.referAndEarn.refer.howItWorks.${key}`);
  return (
    <div className="px-2">
      <div className="flex flex-col max-w-5xl mx-auto py-10">
        <h1
          className={cn(
            textVariants({ size: "xxxl", font: "bold" }),
            "text-center max-sm:text-base"
          )}
        >
          {trans("header")}
        </h1>
        <div className="flex flex-col divide-y divide-gray-300 dark:divide-grey-500">
          <div className="flex items-center gap-8  py-8 md:py-16">
            <div className="flex md:justify-center items-center">
              <img src={registerearn} alt="register" className="w-32" />
            </div>
            <div className="">
              <h1
                className={cn(
                  textVariants({ size: "xxl", font: "bold" }),
                  "text-left max-sm:text-base"
                )}
              >
                {trans("steps.step1.title")}
              </h1>
              <p
                className={cn(
                  textVariants({ size: "lg", font: "normal" }),
                  "text-left max-sm:text-sm"
                )}
              >
                {trans("steps.step1.desc")}
              </p>
            </div>
          </div>
          <div className="flex items-center flex-row-reverse gap-8 py-8 md:py-16">
            <div className="md:w-1/5 flex md:justify-center items-center">
              <img src={shareearn} alt="share" className="w-24" />
            </div>
            <div className="">
              <h1
                className={cn(
                  textVariants({ size: "xxl", font: "bold" }),
                  "text-left max-sm:text-base"
                )}
              >
                {trans("steps.step2.title")}
              </h1>
              <p
                className={cn(
                  textVariants({ size: "lg", font: "normal" }),
                  "text-left max-sm:text-sm"
                )}
              >
                {trans("steps.step2.desc")}
              </p>
            </div>
          </div>
          <div className="flex items-center flex-row gap-8 py-8 md:py-16">
            <div className="md:w-1/5 flex md:justify-center items-center">
              <img src={dividend} alt="earn" className="w-24" />
            </div>
            <div className="">
              <h1
                className={cn(
                  textVariants({ size: "xxl", font: "bold" }),
                  "text-left max-sm:text-base"
                )}
              >
                {trans("steps.step3.title")}
              </h1>
              <p
                className={cn(
                  textVariants({ size: "lg", font: "normal" }),
                  "text-left max-sm:text-sm"
                )}
              >
                {trans("steps.step3.desc")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
